module.exports = __webpack_public_path__ + "img/support_a10.a56c5421.png";